import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import LinkedModal from "../LinkedModal/LinkedModal";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const WiringManual = props => {
  const {getApiPrimaryParams, setPrintData, unsetPrintData} = useTecRmi()
  const [linkedId, setLinkedId] = useState()
  const [manualHtml, setManualHtml] = useState()

  useEffect(() => () => unsetPrintData(), [])

  useDidMountEffect(() => {
    window.clickOnElement = (id) => setLinkedId(parseInt(id))

    const params = {
      ...getApiPrimaryParams(),
      manualId: props.manualId,
      printView: false,
      kindOfWorkTime: 0,
      linkUrl: '',
    }

    setPrintData(apiUser.tecRmi.wiring.manualHtmlPrint, {
      ...params,
      printView: true,
    })

    apiUser.tecRmi.wiring.manualHtml(params)
      .then(res => setManualHtml(res.data))
  })

  const handleLinkedModalClose = () => {
    setLinkedId(null)
    window.clickOnElement = (id) => setLinkedId(parseInt(id))
  }

  const handleClick = (e) => {
    if(e.target.closest('a') && e.target.closest('a').getAttribute('href')){
      e.preventDefault()

      const href = e.target.closest('a').getAttribute('href').replaceAll('Þ', '')
      const oper = href.replace(/\d+/g, '')
      const id = href.replace(/^\D+/g, '')
    }
  }

  return (
    <div>
      {manualHtml ? <TecRmiSvgHtml html={manualHtml[0]} handleClick={handleClick} excludeJsFunctions={['clickOnElement']} /> : <LoadingSpinner />}
      {linkedId && <LinkedModal
        onClose={handleLinkedModalClose}
        id={linkedId}
        wiringDiagramsFn={apiUser.tecRmi.wiring.linkedWiringDiagrams}
        fuseRelaisFn={apiUser.tecRmi.wiring.linkedFuseRelais}
        diagnosticsFn={apiUser.tecRmi.wiring.linkedDiagnostics}
      />}
    </div>
  );
};

WiringManual.propTypes = {
  manualId: PropTypes.number.isRequired,
};

export default WiringManual;